<template>
  <nav id="sideBar">
    <v-navigation-drawer v-model="drawer" dark src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTXRylJTyHTk4y_9HI5AkPTeNJH--7jBOS2eut1QFtXPAdVFhy1-pIIMOmMcOJt6Pwg0hc&usqp=CAU" app :mini-variant.sync="mini">
      <template v-slot:prepend>
        <v-list-item class="px-2">

          <img src="../../public/gshlogo.png" height="35" width="40">

          <v-list-item-content>
            <v-list-item-title><span style="font-size:15px;padding-left:10px">Georgetown Specialist</span><br><span style="font-size:15px;padding-left:10px">Hospital (GSH)</span></v-list-item-title>

          </v-list-item-content>
          <v-btn icon @click.stop="mini = !mini">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-list-item>
      </template>

      <v-divider></v-divider>
      <v-list nav>

        <v-list>
          <v-list-item v-for="item in overview" :key="item.title" link :to="item.path">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-list-group :value="false" prepend-icon="mdi-cog" v-if="$keycloak.realmAccess.roles.includes('admin')">
          <template v-slot:activator>
            <v-list-item-title>Settings</v-list-item-title>
          </template>

          <v-list-item v-for="item in manage" :key="item.title" link :to="item.path">
            <v-list-item-icon>

            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                <v-icon>{{ item.icon }}</v-icon>{{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
      <template v-slot:append v-if="!mini">
        <div class="pa-2">
          <v-btn block color="red" @click="$keycloak.logoutFn" v-if="$keycloak.authenticated">
            Sign Out
            <v-icon right dark>
              mdi-logout-variant
            </v-icon>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
  </nav>
</template>

<script>
export default {
  data() {
      return {
        drawer: true,
        mini: false,
      overview: [
        {title: 'Overview', icon: 'mdi-view-dashboard', path:'/' },
        {title: 'Alert', icon: 'mdi-alert-box', path:'/alert' },
      ],
      manage: [
        {title: 'Seismic', icon: 'mdi-chevron-right', path:'/smp-data'},
        {title: 'Location', icon: 'mdi-chevron-right', path:'/location' },
      ],
      };
  },
  computed: {
    loginUser() {
      return this.$store.getters["loginUser/getDetails"];
    },
  },
  created: function() {
    this.$store.dispatch("loginUser/setCurrentUser", {
      firstName: this.$keycloak.tokenParsed.given_name,
      lastName: this.$keycloak.tokenParsed.family_name,
    }); 
}
}

</script>

<style scoped>
@media print {
  #sideBar {
   display: none;
   overflow: hidden;
  }
}
</style>